import { Search, FileCheck2, Gavel, Banknote } from "lucide-react";
import Reveal from "./Reveal";

const STEPS = [
  { n: "01", icon: <Search className="w-6 h-6" />, title: "Free Records Search", body: "Tell us about the foreclosed property. We dig into county and court records to confirm whether surplus funds exist for your case." },
  { n: "02", icon: <FileCheck2 className="w-6 h-6" />, title: "Verify Your Right to Claim", body: "We confirm your identity, ownership history, and any junior liens. No claim is filed until we're confident you'll win." },
  { n: "03", icon: <Gavel className="w-6 h-6" />, title: "Court Filings & Petition", body: "Our specialists prepare and file the petition for excess proceeds with the proper court — you don't lift a finger." },
  { n: "04", icon: <Banknote className="w-6 h-6" />, title: "Get Paid", body: "Once the court approves the release, funds are disbursed to you. Our fee comes out of the recovery — never your pocket." },
];

export default function HowItWorks() {
  return (
    <section
      id="process"
      className="relative py-20 sm:py-24 lg:py-32 overflow-hidden"
      data-testid="process-section"
    >
      {/* Background image with dark overlay for legibility */}
      <img
        src="https://customer-assets.emergentagent.com/job_foreclosure-leads/artifacts/zauobhbj_home-3-BwxQjBAu.jpg"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0F172A]/85 via-[#0F172A]/80 to-[#0F172A]/90" />
      <div className="absolute inset-0 bg-[#0F172A]/30" />

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <Reveal>
          <div className="max-w-3xl mb-12 sm:mb-16">
            <p className="text-sm sm:text-base font-bold uppercase tracking-[0.18em] text-[#FF008F] mb-4">Our Process</p>
            <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#F7F5F0] leading-tight">
              A clear, four-step path to recovering your money.
            </h2>
            <p className="mt-4 text-[#F7F5F0]/70 max-w-xl">
              From the first records search to the moment the check clears — we handle every step so you don't have to.
            </p>
          </div>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.1}>
            <article className="relative h-full bg-[#F7F5F0]/95 backdrop-blur-sm rounded-2xl border border-[#F7F5F0]/40 p-6 sm:p-7 shadow-xl shadow-[#0F172A]/20 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1" data-testid={`step-card-${i + 1}`}>
              <div className="flex items-start justify-between">
                <div className="w-12 h-12 rounded-xl bg-[#1E3A8A] text-white grid place-items-center">{s.icon}</div>
                <span className="font-serif-display text-2xl text-[#FF008F]/40">{s.n}</span>
              </div>
              <h3 className="font-serif-display text-xl text-[#0F172A] mt-5">{s.title}</h3>
              <p className="text-sm text-[#475569] mt-2 leading-relaxed">{s.body}</p>
            </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
